module.exports = __webpack_public_path__ + "static/springnews_logo-7cfb20eff12588077385bfc8a6ef4f5b.png";